module.exports = __webpack_public_path__ + "static/media/judge-pan-yaozhang.46adb94c.jpg";